<ion-grid class="open-hours">
  <ion-row class="text-small">
    @if (tradingScheduleConfiguration$ | async; as tradingScheduleConfiguration) {
      @if (tradingScheduleConfiguration) {
        <ion-col size="6"
                class="ion-text-start">
          <div [class.open]="tradingScheduleConfiguration.scheduleInterval === ScheduleInterval.INSIDE"
              [class.closed]="tradingScheduleConfiguration.scheduleInterval === ScheduleInterval.OUTSIDE">
            <div class="opening-hours-trading">{{ 'opening-hours.trading' | translate }}</div>
            <ion-badge class="status-badge"
                       [class.badge-open]="tradingScheduleConfiguration.scheduleInterval === ScheduleInterval.INSIDE"
                       [class.badge-closed]="tradingScheduleConfiguration.scheduleInterval === ScheduleInterval.OUTSIDE">
              {{ 'opening-hours.' + tradingScheduleConfiguration.scheduleInterval | lowercase | translate }}
            </ion-badge>
            <div>
              @if (tradingScheduleConfiguration.scheduleInterval === ScheduleInterval.INSIDE) {
                <span>
                  {{ 'opening-hours.closes-date' | translate:
                    getScheduleConfigurationTranslateArgs(tradingScheduleConfiguration) }}
                  <br>
                  {{ 'opening-hours.closes-time' | translate:
                    getScheduleConfigurationTranslateArgs(tradingScheduleConfiguration) }}
                </span>
              }
              @if (tradingScheduleConfiguration.scheduleInterval === ScheduleInterval.OUTSIDE) {
                <span>
                  {{ 'opening-hours.open-date' | translate:
                  getScheduleConfigurationTranslateArgs(tradingScheduleConfiguration) }}
                  <br>
                  {{ 'opening-hours.open-time' | translate:
                  getScheduleConfigurationTranslateArgs(tradingScheduleConfiguration) }}
                </span>
              }
            </div>
          </div>
        </ion-col>
      }
    }
    @if (supportScheduleConfiguration$ | async; as supportScheduleConfiguration) {
      @if (supportScheduleConfiguration) {
        <ion-col size="6"
                class="ion-text-end">
          <div [class.open]="supportScheduleConfiguration.scheduleInterval === ScheduleInterval.INSIDE"
               [class.closed]="supportScheduleConfiguration.scheduleInterval === ScheduleInterval.OUTSIDE">
            <div class="opening-hours-support">{{ 'opening-hours.support' | translate }}</div>
            <ion-badge class="status-badge"
                       [class.badge-open]="supportScheduleConfiguration.scheduleInterval === ScheduleInterval.INSIDE"
                       [class.badge-closed]="supportScheduleConfiguration.scheduleInterval === ScheduleInterval.OUTSIDE">
              {{ 'opening-hours.' + supportScheduleConfiguration.scheduleInterval | lowercase | translate }}
            </ion-badge>
            <div>
              @if (supportScheduleConfiguration.scheduleInterval === ScheduleInterval.INSIDE) {
                <span>
                  {{ 'opening-hours.closes-date' | translate:
                    getScheduleConfigurationTranslateArgs(supportScheduleConfiguration) }}
                  <br>
                  {{ 'opening-hours.closes-time' | translate:
                    getScheduleConfigurationTranslateArgs(supportScheduleConfiguration) }}
                </span>
              }
              @if (supportScheduleConfiguration.scheduleInterval === ScheduleInterval.OUTSIDE
              && isDefined(supportScheduleConfiguration.formattedDate)) {
                <span>
                  {{ 'opening-hours.open-date' | translate:
                    getScheduleConfigurationTranslateArgs(supportScheduleConfiguration) }}
                  <br>
                  {{ 'opening-hours.open-time' | translate:
                    getScheduleConfigurationTranslateArgs(supportScheduleConfiguration) }}
                </span>
              }
            </div>
          </div>
        </ion-col>
      }
    }
  </ion-row>
</ion-grid>